import styled from "styled-components";
import { returnScaleByWidth, scaleCalc } from "../../../helpers/scaleCalc";

/**
 * @prop {integer} width
 * @prop {integer} height
 */
export const WrapperBannerScale = styled.div`
  display: block;
  width: ${(props) => scaleCalc(props.width, props.height)[0]}px;
  height: ${(props) => scaleCalc(props.width, props.height)[1]}px;
`;

/**
 * @prop {integer} width
 * @prop {integer} height
 * @prop {boolean} layoutStage
 */
export const ContainerStep = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid white;
  z-index: 900;
  transform: ${(props) =>returnScaleByWidth(props.width, props.height, false, props.layoutStage)};
  transform-origin: 0 0;
`;

/**
 * @prop {integer} width
 * @prop {integer} height
 * @prop {boolean} layoutStage
 */
export const ContainerBackup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 70px 30px 0px;
  zoom: ${(props) =>
    returnScaleByWidth(props.width, props.height, true, props.layoutStage)};
  transform-origin: 0 0;
`;

/**
 * @prop {integer} width
 * @prop {boolean} layoutStage
 */
export const ContainerRootStage = styled.div`
  display: flex;
  margin: auto;
  transform: ${(props) =>
    props.layoutStage && props.width > 1100
      ? props.width > 2000
        ? "scale(0.45)"
        : "scale(0.75)"
      : "scale(1)"};
  flex-direction: ${props => props.layoutStage ? "row" : "column"};
`;
